import Backbone from 'backbone';
import {
  CUSTOM_COMPARISON_SELECTED,
  CUSTOM_PERIOD_SELECTED,
} from 'common/constants';
import moment from 'moment';
import Pikaday from 'pikaday';

Backbone.$ = $;

export default Backbone.View.extend({
  events: {
    'click #doneButton': 'onCustomPeriodChosen',
  },

  hide() {
    this.$el.modal('hide');
  },

  initialize() {
    this.forComparison = false;
    this.startPicker = new Pikaday({
      field: $('#startPicker')[0],
    });
    this.endPicker = new Pikaday({
      field: $('#endPicker')[0],
    });
  },

  onCustomPeriodChosen() {
    let start = this.startPicker.getDate();
    let end = this.endPicker.getDate();
    const eventName = this.forComparison
      ? CUSTOM_COMPARISON_SELECTED
      : CUSTOM_PERIOD_SELECTED;
    if (moment(end).isBefore(start)) {
      const temp = end;
      end = start;
      start = temp;
    }
    this.hide();
    this.trigger(eventName, {
      start,
      end,
      target: this,
    });
  },

  render(collections) {
    const collection = collections[0];
    this.startPicker.setDate(collection.getStartTimestamp());
    this.endPicker.setDate(collection.getEndTimestamp());
  },

  show(forComparison) {
    this.forComparison = forComparison;
    this.$el.modal();
  },
});
